"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_PREFERENCES = void 0;
exports.DEFAULT_PREFERENCES = {
    theme: 'system',
    defaultModelId: null,
    hiddenModelIds: [],
    sendWithEnter: true,
    showModelDescriptions: true,
    compactMessageView: false,
};
//# sourceMappingURL=preferences.js.map